if (!customElements.get('sc-upsell-add')) {
  customElements.define(
    'sc-upsell-add',
    class ScUpsellAdd extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.form || !this.submitButton) return;

        this.initialized = true;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.spinner = this.querySelector('.loading__spinner');
        this.error = false;

        const variantInput = this.form.querySelector('[name="id"]');
        if (variantInput) variantInput.disabled = false;

        if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.spinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.error = true;
              console.error(response.description || response.message);
              return;
            }

            this.error = false;

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sc-upsell-add',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.spinner?.classList.add('hidden');
            if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }
    }
  );
}

/**
 * Cart-drawer upsell must load eagerly: the empty shell is often outside the
 * viewport / inside a closed drawer, so IntersectionObserver never fires.
 */
function scLoadCartUpsell(root = document) {
  const el = root.querySelector('#sc-cart-upsell[data-sc-eager-load="true"]');
  if (!el || el.dataset.scFetched === 'true' || !el.dataset.productId) return;

  el.dataset.scFetched = 'true';

  fetch(`${el.dataset.url}&product_id=${el.dataset.productId}&section_id=${el.dataset.sectionId}`)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');

      if (recommendations?.innerHTML.trim().length) {
        el.innerHTML = recommendations.innerHTML;
        el.classList.add('sc-upsell--loaded');
      } else {
        el.classList.add('sc-upsell--empty');
      }
    })
    .catch((error) => {
      console.error(error);
      el.classList.add('sc-upsell--empty');
    });
}

// Script may be included from both product + cart upsell snippets — run once.
if (!window.scUpsellBootstrapped) {
  window.scUpsellBootstrapped = true;

  document.addEventListener('DOMContentLoaded', () => scLoadCartUpsell());

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(() => scLoadCartUpsell());
    });
  }

  document.addEventListener('shopify:section:load', (event) => scLoadCartUpsell(event.target));

  const scCartDrawer = document.querySelector('cart-drawer');
  if (scCartDrawer) {
    let scCartUpsellTimer;
    const scCartUpsellObserver = new MutationObserver(() => {
      clearTimeout(scCartUpsellTimer);
      scCartUpsellTimer = setTimeout(() => scLoadCartUpsell(scCartDrawer), 50);
    });
    scCartUpsellObserver.observe(scCartDrawer, { childList: true, subtree: true });
  }
}
